var map = {
	"./about_us.png": 7372,
	"./dummy.png": 628,
	"./group.png": 3528,
	"./licence1.gif": 7176,
	"./licence2.gif": 236,
	"./licence3.gif": 9304,
	"./licence4.gif": 8672,
	"./licence5.gif": 1862,
	"./licence6.gif": 2052,
	"./licence7.gif": 4876,
	"./licence8.gif": 6312,
	"./logo.png": 5600,
	"./main_banner.jpg": 3340,
	"./partner1.svg": 8200,
	"./partner2.svg": 5064,
	"./partner3.png": 168,
	"./partner4.gif": 136,
	"./partner5.svg": 8068,
	"./partner6.jpeg": 3712,
	"./partner7.svg": 6724,
	"./partner8.png": 7556,
	"./partner9.jpeg": 688,
	"./point1.png": 1376,
	"./point2.png": 6612,
	"./service1-1.jpeg": 9776,
	"./service1-2.jpeg": 6224,
	"./service1-3.jpeg": 5432,
	"./service1-4.jpeg": 6456,
	"./service1-5.jpeg": 7620,
	"./service1-6.jpeg": 5236,
	"./service1.jpg": 4988,
	"./service2-1.jpeg": 6915,
	"./service2.jpg": 7444,
	"./service3-1.jpeg": 8535,
	"./service3-2.jpeg": 404,
	"./service3-3.jpeg": 2308,
	"./service3.jpg": 9528,
	"./service4-1.jpeg": 6316,
	"./service4-2.jpeg": 8783,
	"./service4-3.jpeg": 5768,
	"./service4.jpg": 5084,
	"./service5.jpg": 3388,
	"./simplelogo.png": 5872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8348;